import { getBackendUrl } from "../../lib/utils";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowRight, Instagram, Facebook, Twitter, Linkedin } from "lucide-react";
import axios from "axios";
import { getImageUrl } from "../../lib/utils";

const Footer = () => {
  const [footerSettings, setFooterSettings] = useState({
    logo_url: "",
    short_desc: "S.S. İkitelli - Silivri Toplu İşyeri Yapı Kooperatifi. Bölgede iş dünyasının ihtiyaçlarına yönelik modern ve kapsamlı üretim-ticaret alanları oluşturmayı hedeflemekteyiz.",
    instagram: "https://instagram.com/isilkoop",
    facebook: "",
    twitter: "",
    linkedin: "",
    youtube: "",
    pinterest: "",
    tiktok: "",
    copyright: "© 2026 S.S. İkitelli - Silivri Toplu İşyeri Yapı Kooperatifi. Tüm Hakları Saklıdır.",
    designed_by: "Designed BiiPixel",
    footer_phone: "",
    footer_email: "",
    footer_address_office: "",
    footer_address_site: ""
  });
  
  const [contactSettings, setContactSettings] = useState({
    phone: "+90 212 877 89 18",
    email: "info@isilkoop.com",
    address_office: "Osb. Mh. Dolapdere Sanayi Sitesi\nDolapdere İş Merkezi No: 27 - 4\nİkitelli / Başakşehir / İstanbul",
    address_site: "Enlem Soğuk Hava Depolama\nLojistik ve Gıda Sanayi A.Ş.\nGümüşyaka, İstanbul Çorlu Yolu\n34580 Silivri / İstanbul"
  });

  useEffect(() => {
    const backendUrl = getBackendUrl();
    axios.get(`${backendUrl}/api/settings`)
      .then(res => {
        if (res.data.footer_settings) setFooterSettings(res.data.footer_settings);
        if (res.data.contact_settings) setContactSettings(res.data.contact_settings);
      })
      .catch(console.error);
  }, []);

  const phone = footerSettings.footer_phone || contactSettings.phone;
  const email = footerSettings.footer_email || contactSettings.email;
  const addressOffice = footerSettings.footer_address_office || contactSettings.address_office;
  const addressSite = footerSettings.footer_address_site || contactSettings.address_site;
  return (
    <footer className="bg-[#0f172a] text-slate-300 py-16 border-t border-slate-800">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Brand & About */}
          <div className="space-y-6">
            <img
              src={footerSettings.logo_url ? getImageUrl(footerSettings.logo_url) : "https://isilkoop.com/assets/images/logo/logo-dark.png"}
              alt="İSİLKOOP"
              className="h-12 object-contain brightness-0 invert" />

            <p className="text-slate-400 text-sm leading-relaxed font-medium">
              {footerSettings.short_desc}
            </p>
            <div className="flex flex-wrap items-center gap-3 pt-2">
              {footerSettings.instagram && (
                <a href={footerSettings.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-300 hover:bg-pink-600 hover:text-white transition-colors duration-300" title="Instagram">
                  <Instagram size={18} />
                </a>
              )}
              {footerSettings.facebook && (
                <a href={footerSettings.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-300 hover:bg-blue-600 hover:text-white transition-colors duration-300" title="Facebook">
                  <Facebook size={18} />
                </a>
              )}
              {footerSettings.twitter && (
                <a href={footerSettings.twitter} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-300 hover:bg-slate-700 hover:text-white transition-colors duration-300" title="Twitter/X">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
              )}
              {footerSettings.linkedin && (
                <a href={footerSettings.linkedin} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-300 hover:bg-blue-700 hover:text-white transition-colors duration-300" title="LinkedIn">
                  <Linkedin size={18} />
                </a>
              )}
              {footerSettings.youtube && (
                <a href={footerSettings.youtube} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-300 hover:bg-red-600 hover:text-white transition-colors duration-300" title="YouTube">
                  <Youtube size={18} />
                </a>
              )}
              {footerSettings.pinterest && (
                <a href={footerSettings.pinterest} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-300 hover:bg-red-700 hover:text-white transition-colors duration-300" title="Pinterest">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                    <path d="M12 0C5.37 0 0 5.37 0 12c0 5.08 3.16 9.42 7.63 11.16-.1-.95-.2-2.4.04-3.43.22-.93 1.4-5.93 1.4-5.93s-.36-.72-.36-1.77c0-1.66.96-2.9 2.17-2.9 1.02 0 1.51.77 1.51 1.69 0 1.03-.65 2.56-.99 3.99-.28 1.19.6 2.16 1.77 2.16 2.12 0 3.76-2.24 3.76-5.47 0-2.86-2.06-4.86-5-4.86-3.4 0-5.4 2.56-5.4 5.2 0 1.03.4 2.13.9 2.73.1.12.1.22.08.33l-.34 1.37c-.05.2-.17.25-.39.15-1.44-.67-2.34-2.77-2.34-4.47 0-3.64 2.65-7 7.64-7 4.02 0 7.14 2.87 7.14 6.7 0 4-2.52 7.22-6.02 7.22-1.18 0-2.29-.61-2.67-1.34l-.73 2.78c-.26 1.02-1 2.3-1.5 3.1 1.13.33 2.33.52 3.57.52 6.63 0 12-5.37 12-12S18.63 0 12 0z"/>
                  </svg>
                </a>
              )}
              {footerSettings.tiktok && (
                <a href={footerSettings.tiktok} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-300 hover:bg-black hover:text-white transition-colors duration-300" title="TikTok">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.02 1.62 4.19 1.22 1.25 2.88 1.95 4.6 2.06v3.83c-1.39-.07-2.74-.55-3.87-1.38-.8-.6-1.42-1.38-1.83-2.29-.02 1.99.01 3.99-.02 5.98-.08 2.38-.88 4.7-2.44 6.5-1.92 2.21-4.82 3.44-7.72 3.27-2.91-.18-5.64-1.74-7.14-4.24-1.74-2.85-1.9-6.55-.42-9.53 1.23-2.48 3.56-4.29 6.27-4.85.73-.15 1.48-.21 2.23-.19.01 1.34.01 2.68.01 4.01-.58-.06-1.18-.02-1.74.16-1.25.39-2.32 1.35-2.79 2.56-.63 1.63-.12 3.63 1.22 4.68.96.76 2.22 1.01 3.42.74 1.16-.27 2.12-1.15 2.5-2.28.1-.31.14-.64.14-.97-.02-3.41-.01-6.82-.02-10.23z"/>
                  </svg>
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg tracking-wide">Kurumsal</h4>
            <ul className="space-y-3 text-sm font-medium">
              <li>
                <Link to="/kurumsal/hakkimizda" className="hover:text-white hover:translate-x-1 transition-all flex items-center gap-2">
                  <ArrowRight size={14} className="text-blue-500" /> Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/kurumsal/misyon-vizyon" className="hover:text-white hover:translate-x-1 transition-all flex items-center gap-2">
                  <ArrowRight size={14} className="text-blue-500" /> Misyon & Vizyon
                </Link>
              </li>
              <li>
                <Link to="/haberler" className="hover:text-white hover:translate-x-1 transition-all flex items-center gap-2">
                  <ArrowRight size={14} className="text-blue-500" /> Haberler
                </Link>
              </li>
              <li>
                <Link to="/galeri" className="hover:text-white hover:translate-x-1 transition-all flex items-center gap-2">
                  <ArrowRight size={14} className="text-blue-500" /> Galeri
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-bold mb-6 text-lg tracking-wide">İletişim Bilgileri</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-blue-900/50 border border-blue-500/20 flex items-center justify-center shrink-0">
                    <MapPin size={18} className="text-blue-400" />
                  </div>
                  <div>
                    <h5 className="text-white text-sm font-bold mb-1">Merkez Ofis</h5>
                    <p className="text-sm text-slate-400 font-medium whitespace-pre-line">
                      {addressOffice}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-emerald-900/50 border border-emerald-500/20 flex items-center justify-center shrink-0">
                    <MapPin size={18} className="text-emerald-400" />
                  </div>
                  <div>
                    <h5 className="text-white text-sm font-bold mb-1">Şantiye Adresi</h5>
                    <p className="text-sm text-slate-400 font-medium whitespace-pre-line">
                      {addressSite}
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <a href={`tel:${phone}`} className="flex items-center gap-4 group hover:opacity-90 transition-opacity">
                  <div className="w-10 h-10 rounded-full bg-slate-800 group-hover:bg-slate-700 flex items-center justify-center shrink-0 transition-colors">
                    <Phone size={18} className="text-blue-400" />
                  </div>
                  <div>
                    <h5 className="text-white text-sm font-bold mb-1">Telefon</h5>
                    <p className="text-sm text-slate-400 font-medium group-hover:text-blue-300 transition-colors">{phone}</p>
                  </div>
                </a>

                <a href={`mailto:${email}`} className="flex items-center gap-4 group hover:opacity-90 transition-opacity">
                  <div className="w-10 h-10 rounded-full bg-slate-800 group-hover:bg-slate-700 flex items-center justify-center shrink-0 transition-colors">
                    <Mail size={18} className="text-blue-400" />
                  </div>
                  <div>
                    <h5 className="text-white text-sm font-bold mb-1">E-Posta</h5>
                    <p className="text-sm text-slate-400 font-medium group-hover:text-blue-300 transition-colors">{email}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>

        </div>

        <div className="mt-16 pt-8 border-t border-slate-800 text-center text-sm font-medium text-slate-500 flex flex-col md:flex-row justify-between items-center gap-4">
          <p>{footerSettings.copyright}</p>
          <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs font-semibold text-slate-400">
            <Link to="/sayfa/kvkk-aydinlatma-metni" className="hover:text-white transition-colors">KVKK Aydınlatma Metni</Link>
            <span className="text-slate-700">|</span>
            <Link to="/sayfa/gizlilik-politikasi" className="hover:text-white transition-colors">Gizlilik Politikası</Link>
          </div>
          <p>{footerSettings.designed_by}</p>
        </div>
      </div>
    </footer>);

};

export default Footer;